/**
 * The published code block's own inline paint. `margin: 0` is the published
 * `.w-code-block { margin: unset }`, without which the user agent's `1em 0`
 * applies.
 *
 * Its own module rather than part of `highlightCode`: a renderer needs the
 * paint but not the library, and every import of that module carries
 * highlight.js and its thirty-seven grammars with it.
 */
export const codePreStyle = {
  display: "block",
  overflowX: "auto",
  background: "#2b2b2b",
  color: "#f8f8f2",
  padding: "0.5em",
  margin: 0,
} as const;
